import { c as _c } from "react/compiler-runtime";
import { colors } from '@newfront-insurance/core-ui';
import { Button, cn } from '@newfront-insurance/core-ui/v2';
import { ArrowUpIcon, Loader2 } from 'lucide-react';
import { useAttachments } from './attachments-provider';
import { useChatInputContext } from './chat-input-context';
import { useChatOverlayContext } from '../../contexts/chat-overlay-context';
interface SendButtonProps {
  className?: string;
}

/**
 * Send button component for chat input.
 * Uses context to access input state and submit handler.
 * Shows loading state when chat is submitting/streaming.
 */
export function SendButton(t0) {
  const $ = _c(25);
  const {
    className
  } = t0;
  const {
    input,
    handleSubmit,
    status
  } = useChatInputContext();
  const {
    attachments
  } = useAttachments();
  const {
    additionalContext
  } = useChatOverlayContext();
  let T0;
  let isDisabled;
  let t1;
  let t2;
  let t3;
  if ($[0] !== additionalContext || $[1] !== attachments || $[2] !== className || $[3] !== input.length || $[4] !== status) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const hasUploadingFiles = attachments.some(_temp);
      const successfulAttachmentUuids = attachments.filter(_temp2).map(_temp3);
      const contextAttachmentFileUuids = Array.isArray(additionalContext?.attachmentFileUuids) ? additionalContext.attachmentFileUuids.filter(_temp4) : [];
      const hasUnsyncedAttachmentContext = successfulAttachmentUuids.length !== contextAttachmentFileUuids.length || successfulAttachmentUuids.some(uuid_0 => !contextAttachmentFileUuids.includes(uuid_0));
      isDisabled = input.length === 0 && attachments.length === 0 || hasUploadingFiles || hasUnsyncedAttachmentContext;
      if (["submitted", "streaming"].includes(status)) {
        let t4;
        if ($[10] !== className) {
          t4 = cn("bg-lime-blue-gradient h-fit rounded-full border-none bg-clip-padding p-2", "text-brand-500 hover:opacity-90", className);
          $[10] = className;
          $[11] = t4;
        } else {
          t4 = $[11];
        }
        let t5;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <Loader2 size={14} className="animate-spin" />;
          $[12] = t5;
        } else {
          t5 = $[12];
        }
        let t6;
        if ($[13] !== t4) {
          t6 = <Button data-testid="loading-button" className={t4} disabled={true}>{t5}</Button>;
          $[13] = t4;
          $[14] = t6;
        } else {
          t6 = $[14];
        }
        t3 = t6;
        break bb0;
      }
      T0 = Button;
      t1 = "send-button";
      t2 = cn("bg-lime-blue-gradient h-fit rounded-full border-none bg-clip-padding p-2", "hover:opacity-90", "border-transparent", className, {
        "cursor-not-allowed bg-[#e5e7eb] opacity-50": isDisabled
      });
    }
    $[0] = additionalContext;
    $[1] = attachments;
    $[2] = className;
    $[3] = input.length;
    $[4] = status;
    $[5] = T0;
    $[6] = isDisabled;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    T0 = $[5];
    isDisabled = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[15] !== handleSubmit || $[16] !== isDisabled) {
    t4 = event => {
      event.preventDefault();
      if (!isDisabled) {
        handleSubmit(undefined);
      }
    };
    $[15] = handleSubmit;
    $[16] = isDisabled;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowUpIcon size={14} color={colors.brand[500]} />;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== T0 || $[20] !== isDisabled || $[21] !== t1 || $[22] !== t2 || $[23] !== t4) {
    t6 = <T0 data-testid={t1} className={t2} onClick={t4} disabled={isDisabled}>{t5}</T0>;
    $[19] = T0;
    $[20] = isDisabled;
    $[21] = t1;
    $[22] = t2;
    $[23] = t4;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}
function _temp4(uuid) {
  return typeof uuid === "string";
}
function _temp3(attachment_1) {
  return attachment_1.fileUuid;
}
function _temp2(attachment_0) {
  return attachment_0.fileUuid && !attachment_0.uploadError;
}
function _temp(attachment) {
  return attachment.isUploading;
}